import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MAIN_DEAL_FULL_DETAILS_COMPONENT } from '../../brands/default/content/components/deal';
import { APPEND_BLACKFRIDAY_LINKS } from '../../brands/default/features';
import { appendBlackFridayLinks } from '../../helpers/blackFriday';
import { isBlackFriday } from '../../helpers/promotions';
import { sanitiseText } from '../../helpers/sanitiseText';
import ThemeContext from '../../providers/ThemeProvider';
import CollapsableSection from './shared-components/CollapsableSection';

const MainDealFullDetails = ({
  deal = null,
  className,
  contentVisible = true,
  collapsed,
  isGoogleHotel = false,
  onToggle,
}) => {
  const contentRef = useRef();
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const isVipUser = useSelector((state) => state?.user?.userprofile?.vipUser);
  const now = new Date();

  let dealDescription =
    isVipUser && deal?.vipDescription
      ? deal?.vipDescription
      : deal?.description;

  if (isBlackFriday(now) && APPEND_BLACKFRIDAY_LINKS) {
    dealDescription = appendBlackFridayLinks({ dealDescription, router });
  }

  useEffect(() => {
    const links = document.querySelectorAll('.deal-main-deal__full-details a');

    links.forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }, [dealDescription]);

  if (!deal || !deal.description) return null;

  return (
    <>
      <CollapsableSection
        collapsed={collapsed}
        onToggle={onToggle}
        title={MAIN_DEAL_FULL_DETAILS_COMPONENT.fullDetails}
      >
        {isGoogleHotel && (
          <p>
            <b>{MAIN_DEAL_FULL_DETAILS_COMPONENT.descriptionForGoogle} </b>
          </p>
        )}
        <div
          className={classNames('deal-main-deal__full-details', className, {
            visible: contentVisible,
          })}
          dangerouslySetInnerHTML={{
            __html: sanitiseText(dealDescription),
          }}
          ref={contentRef}
        />
      </CollapsableSection>
      <style jsx>{`
        .deal-main-deal__full-details {
          position: relative;
          visibility: hidden;
        }

        .deal-main-deal__full-details.visible {
          visibility: visible;
        }

        :global(.deal-main-deal__full-details ul) {
          list-style: none;
          padding-left: 0;
        }

        :global(.deal-main-deal__full-details li) {
          position: relative;
          list-style: none;
          margin-left: 16px;
        }

        :global(.deal-main-deal__full-details li:before) {
          position: absolute;
          display: inline-block;
          content: '';
          height: 6px;
          width: 6px;
          background-color: ${theme.colors.primary};
          border-radius: 50%;
          top: 0.5em;
          left: -16px;
        }

        :global(.deal-main-deal__full-details a) {
          color: ${theme.colors.primary};
        }

        :global(.deal-main-deal__full-details iframe),
        :global(.deal-main-deal__full-details img),
        :global(.deal-main-deal__full-details video) {
          width: 100%;
        }
      `}</style>
    </>
  );
};

MainDealFullDetails.MAX_HEIGHT = 150;
MainDealFullDetails.MARGIN_BOTTOM = 30;

MainDealFullDetails.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  contentVisible: PropTypes.bool,
  deal: PropTypes.object,
  isGoogleHotel: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default MainDealFullDetails;
